import { useLocation } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { useTour } from '@/lib/tour/useTour';
import { tourIdForPath } from '@/lib/tour/tourContent';
import { useT } from '@/lib/i18n/useT';

/**
 * Top-bar button that replays the current page's tour on demand. Renders only
 * on pages that actually have a tour, so it never sits dead. Manual launch
 * ignores the "seen" flag — that's the whole point of replaying.
 */
export function TourLauncher() {
  const { pathname, search } = useLocation();
  const { startTour } = useTour();
  const t = useT();

  const tourId = tourIdForPath(pathname, search);
  if (!tourId) return null;

  return (
    <button
      type="button"
      onClick={() => startTour(tourId)}
      aria-label={t('tour.start')}
      title={t('tour.start')}
      className="grid h-10 w-10 flex-none place-items-center rounded-md text-[var(--color-xk-lavender)] transition-colors hover:bg-[var(--color-xk-surface)] hover:text-[var(--color-accent-ink)]"
    >
      <Compass className="h-5 w-5" />
    </button>
  );
}
